import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import type {EntityDescriptionElementViewModel} from "../../../domain/entity-description/models/element/entity-description.element.view-model";

export class EntityDescriptionFaqElementViewModel extends BaseViewModel {
  question: EntityDescriptionElementViewModel;
  answer: EntityDescriptionElementViewModel

  constructor(question: EntityDescriptionElementViewModel, answer: EntityDescriptionElementViewModel) {
    super();

    this.question = question;
    this.answer = answer;
  }

  get boldQuestion() {
    return `<b>${this.question.value}</b>`
  }

  toString() {
    return [this.boldQuestion, this.answer.value].join('<br>');
  }
}